import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { fetchSegments } from '../actions'

import tableRowEpics from './TableRow/epics'
import {
  addSegmentError,
  addSegmentSuccess,
  deleteSegmentsError,
  deleteSegmentsSuccess,
  fetchTagsError,
  fetchTagsSuccess,
} from './actions'
import { ADD_ASYNC, DELETE_MANY_ASYNC, TAGS_REQUEST_ASYNC } from './constants'

const addSegmentEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(ADD_ASYNC.INITIATE),
    mergeMap(() => {
      const state = state$.value
      return api.mailboxes
        .addSegment(state.partnerOptions.selectedCompany?.value, {
          name: state.form.AddSegmentForm.values.name,
          included_tags: state.mailboxes.segments.addNewSegment.includedTags.map((elem) => ({
            id: elem.value,
            name: elem.label,
          })),
          excluded_tags: state.mailboxes.segments.addNewSegment.excludedTags.map((elem) => ({
            id: elem.value,
            name: elem.label,
          })),
        })
        .pipe(
          mergeMap(({ response }) =>
            response.success
              ? of(fetchSegments(), addSegmentSuccess(response || {}))
              : of(addSegmentSuccess(response || {}))
          ),
          catchError((error) => of(epicsErrorHandler(addSegmentError, error))),
          takeUntil(action$.pipe(ofType(ADD_ASYNC.CANCEL)))
        )
    })
  )

const deleteSegmentsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DELETE_MANY_ASYNC.INITIATE),
    mergeMap(() =>
      api.mailboxes
        .deleteSegments(state$.value.partnerOptions.selectedCompany?.value, {
          name: 'Server hack',
          ids: Object.keys(state$.value.mailboxes.segments.selectedIds).map((elem) => ({
            id: elem,
          })),
        })
        .pipe(
          mergeMap(({ response }) =>
            response.success
              ? of(fetchSegments(), deleteSegmentsSuccess(response || {}))
              : of(deleteSegmentsSuccess(response || {}))
          ),
          catchError((error) => of(epicsErrorHandler(deleteSegmentsError, error))),
          takeUntil(action$.pipe(ofType(DELETE_MANY_ASYNC.CANCEL)))
        )
    )
  )

const fetchTagsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(TAGS_REQUEST_ASYNC.INITIATE, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.self) !== -1
      return true
    }),
    mergeMap(() =>
      api.mailboxes
        .getTags({
          companyId: state$.value.partnerOptions.selectedCompany?.value,
          allTags: false,
          page: state$.value.mailboxes.segments.tags.page,
          search: state$.value.mailboxes.segments.tags.search,
        })
        .pipe(
          map((response) => fetchTagsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchTagsError, error))),
          takeUntil(action$.pipe(ofType(TAGS_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(tableRowEpics, addSegmentEpic, deleteSegmentsEpic, fetchTagsEpic)
